<template>
  <!--outlets modal-->
  <b-modal
    :id="modalId"
    size="lg"
    centered
    @hide="$bvModal.hide(modalId)"
    :hide-footer="true"
    :hide-header="true"
  >
    <div class="view-details">
      <div class="modal-close">
        <a href="javascript:void(0)" @click="$bvModal.hide(modalId)" class="">
          <svg class="closeIcon" fill="none">
            <use xlink:href="#closeIcon" />
          </svg>
        </a>
      </div>
      <div class="container-fluid p-0">
        <div class="row m-0" v-if="brandWiseStores.length">
          <div class="col-5 d-none d-lg-block p-0">
            <div class="left-image ratio3_2">
              <div
                v-if="isStoreBrand"
                v-bind:style="{
                  backgroundImage: `url(${
                    isStoreBrand[siteDomain + '_background_image']
                  })`,
                }"
              ></div>
              <div
                v-else-if="brandImage"
                v-bind:style="{
                  backgroundImage: `url(${brandImage})`,
                }"
              ></div>
            </div>
          </div>
          <div class="col-xl-7 col-lg-12 p-0">
            <div class="right-content">
              <div class="right-content-title" v-if="isStoreBrand">
                <h4>{{ _T('Your outlet') }}</h4>
                <h6>1 {{ _T('outlet near you') }}</h6>
              </div>
              <div class="right-content-title" v-else>
                <h4>{{ _T('choose your outlet') }}</h4>
                <h6>
                  {{ brandWiseStores.length }} {{ _T('outlets near you') }}
                </h6>
              </div>
              <div class="right-content-details" v-if="isStoreBrand">
                <ul>
                  <li>
                    <div class="location-box">
                      <router-link
                        :to="{
                          name: brandStoreRoute('store_page'),
                          params: {
                            brand_id: set_website_slug(selectedBrandData),
                            store_id: set_website_slug(isStoreBrand),
                            delivery_area: currentDeliveryArea,
                          },
                        }"
                      >
                        <div>
                          <svg class="outlets">
                            <use class="fill-white" xlink:href="#store" />
                          </svg>
                        </div>
                      </router-link>
                    </div>
                    <router-link
                      class="middle-content"
                      :to="{
                        name: brandStoreRoute('store_page'),
                        params: {
                          brand_id: set_website_slug(selectedBrandData),
                          store_id: set_website_slug(isStoreBrand),
                          delivery_area: currentDeliveryArea,
                        },
                      }"
                    >
                      <div>
                        <p>
                          {{ _T_DB(isStoreBrand, 'address') }}
                        </p>
                        <a class="choose-btn" href="#">
                          <svg class="rightarrow" fill="none">
                            <use
                              class="fill-primary"
                              :xlink:href="'#' + getArrowAlignment"
                            />
                          </svg>
                        </a>
                      </div>
                    </router-link>
                  </li>
                </ul>
              </div>
              <div
                class="right-content-details"
                v-else-if="brandWiseStores.length"
              >
                <ul>
                  <li
                    v-for="(store, index) in brandWiseStores"
                    :key="`${store._id}_${index}`"
                    :class="{ 'overlay-store-closed': !isStoreOpen(store) }"
                  >
                    <div class="location-box">
                      <router-link
                        :to="{
                          name: brandStoreRoute('store_page'),
                          params: {
                            brand_id: set_website_slug(selectedBrandData),
                            store_id: set_website_slug(store),
                            delivery_area: currentDeliveryArea,
                          },
                        }"
                      >
                        <div>
                          <svg class="outlets">
                            <use class="fill-white" xlink:href="#store" />
                          </svg>
                          <!-- <div class="location-detail">
                            <svg class="mapPinW" fill="none">
                              <use class="fill-white" xlink:href="#mapPinW" />
                            </svg>
                            <span>16 km</span>
                          </div> -->
                        </div>
                      </router-link>
                    </div>
                    <router-link
                      class="middle-content"
                      :to="{
                        name: brandStoreRoute('store_page'),
                        params: {
                          brand_id: set_website_slug(selectedBrandData),
                          store_id: set_website_slug(store),
                          delivery_area: currentDeliveryArea,
                        },
                      }"
                    >
                      <div>
                        <p>
                          <!--{{ _T_DB(store, 'city') }},{{
                            _T_DB(store, 'country')
                          }}
                          -{{ _T_DB(store, 'name') }} -->
                          {{ _T_DB(store, 'address') }}
                        </p>
                        <a class="choose-btn" href="#">
                          <svg class="rightarrow" fill="none">
                            <use
                              class="fill-primary"
                              :xlink:href="'#' + getArrowAlignment"
                            />
                          </svg>
                        </a>
                      </div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row m-0 no-storefound" v-else>
          <h4 class="mb-1">
            {{ _T('Sorry, No store found for this brand') }}...
          </h4>
          <p class="mb-0">
            {{
              _T(
                `We can't find nearest store for this brand, you can go for another brands`
              )
            }}.
          </p>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StorePicker',
  props: ['openStoreList'],
  data() {
    return {
      modalId: 'storepicker-id',
    }
  },
  computed: {
    ...mapGetters([
      'getArrowAlignment',
      'selectedBrandData',
      'isStoreBrand',
      'siteDomain',
      '_T',
      '_T_DB',
      'domainBasedBrand',
      'selectedOffer',
      'find_stores_by_brand_id',
      'currentBrand',
      'brandImage',
      'isStoreOpen',
      'brandWiseStores',
      'brandStoreRoute',
      'currentDeliveryArea',
      'set_website_slug',
    ]),
    offer() {
      return this.selectedOffer
    },
  },
  beforeMount() {
    if (this.domainBasedBrand)
      this.$store.commit('SET_SELECTED_BRAND', this.domainBasedBrand)
  },
  /*watch: {
    lang_direction() {
      alert(this.lang_direction)
      this.$nextTick(() => {
        if (this.lang_direction === 'rtl') {
          this.arrowAlignment = 'left-arrow'
        } else {
          this.arrowAlignment = 'rightarrow'
        }
      })
    }
  },*/
  /*methods: {
    setDirection() {
      alert(this.lang_direction)
      if (this.lang_direction === 'rtl') {
        this.arrowAlignment = 'left-arrow'
      } else {
        this.arrowAlignment = 'rightarrow'
      }
    },
  }*/
}
</script>
<style lang="scss" scoped>
.body-rtl {
  .modal-content {
    .modal-body {
      .view-details {
        .right-content {
          .right-content-title {
            text-align: right;
          }
          .right-content-details {
            ul {
              padding-right: unset;
              padding-left: 0;
              li {
                .middle-content {
                  margin-left: unset;
                  margin-right: 1.5rem;
                  padding-right: unset;
                  padding-left: 2rem;
                  p {
                    text-align: right;
                  }
                  .choose-btn {
                    right: unset;
                    left: 0.625rem;
                    svg {
                      margin-left: unset;
                      margin-right: 0.5rem;
                    }
                  }
                }
              }
            }
          }
        }
        .modal-close {
          right: unset;
          left: 2.125rem;
        }
      }
    }
  }
}

.closeIcon {
  height: $px24;
  width: $px24;
}
.outlets {
  height: $px30;
  width: $px30;
}
.mapPinW {
  height: $px14;
  width: $px14;
}
.rightarrow {
  height: $px18;
  width: $px18;
  .right-arrow {
    fill: $color-primary;
  }
}
.modal-content {
  .modal-body {
    .view-details {
      padding-right: 0 !important;
      margin: -$px16;
      .modal-close {
        position: absolute;
        right: $px34;
        top: $px40;
        z-index: 1;
      }
      .left-image {
        height: 100%;
        padding: $px4 0 $px4 $px4;
        > div {
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          display: block;
          height: 100%;
        }
        .bg-size {
          background-size: contain;
          background-position: center;
          margin-left: $px15;
        }
      }
      .right-content {
        padding: $px35;
        .right-content-title {
          border-bottom: $px1 solid $dark-border;
          padding-bottom: $px30;
          h4 {
            text-transform: capitalize;
            font-weight: 600;
            margin-bottom: $px5;
          }
          h6 {
            line-height: $px22;
            margin-bottom: -$px3;
          }
        }
        .right-content-details {
          ul {
            overflow: hidden;
            max-height: $px230;
            overflow-y: auto;
            // &::-webkit-scrollbar {
            //   display: none;
            // }
            &::-webkit-scrollbar {
              width: $px6;
            }
            /* Track */
            &::-webkit-scrollbar-track {
              background: $scrollbar-track;
              border-radius: $px6;
            }
            /* Handle */
            &::-webkit-scrollbar-thumb {
              background: $scrollbar-thumb;
              border-radius: $px4;
            }
            /* Handle on hover */
            &::-webkit-scrollbar-thumb:hover {
              background: darken($scrollbar-track, 0.2);
            }
            li {
              display: flex;
              padding-top: $px28;
              .location-box {
                width: $px76;
                height: $px85;
                background-color: $color-primary;
                box-shadow: 0px $px4 $px14 rgba($black, 0.07);
                border-radius: $px4;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                .location-detail {
                  display: flex;
                  align-items: center;
                  margin-top: $px12;
                  img,
                  svg {
                    margin-right: $px6;
                  }
                  span {
                    font-size: $px12;
                    line-height: $px15;
                    color: $white;
                  }
                }
              }
              .middle-content {
                margin-left: $px24;
                border-bottom: $px1 solid $light-border;
                width: 75%;
                padding-right: $px32;
                position: relative;
                .choose-btn {
                  width: $px35;
                  height: $px80;
                  border-radius: $px4;
                  background-color: rgba(var(--color-primary-source), 0.1);
                  display: flex;
                  align-items: center;
                  text-align: center;
                  position: absolute;
                  right: $px10;
                  top: 0;
                  svg {
                    margin-left: $px8;
                    path {
                      fill: $color-primary;
                    }
                  }
                }
                p {
                  text-transform: capitalize;
                  line-height: $px22;
                  padding-top: $px10;
                  max-width: 90%;
                }
              }
              &:last-child {
                .middle-content {
                  border-bottom: 0;
                }
              }
            }
          }
        }
      }
      .no-storefound {
        padding: $px30;
        h4 {
          font-weight: 600;
        }
      }
    }
  }
}
use {
  &.default-color {
    fill: var(--color-warning-color-source);
  }
}
@media (max-width: 1199px) {
  .modal-content {
    .modal-body {
      .view-details {
        .right-content {
          .right-content-details {
            ul {
              li {
                .middle-content {
                  width: 100%;
                  .choose-btn {
                    right: $px2;
                  }
                }
                .location-box {
                  width: $px100;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .modal-body {
    .modal-close {
      right: $px14;
      top: $px14;
    }
    .right-content {
      padding: $px15;
      .right-content-title {
        padding-bottom: $px15;
        h4 {
          margin-bottom: 0;
        }
      }
      .right-content-details {
        ul {
          li {
            padding-top: $px10;
            margin-left: $px14;
            .middle-content {
              padding-right: 0;
              max-width: 66%;
              p {
                line-height: $px17;
                font-size: $px10;
              }
              .choose-btn {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
